export const keyFeaturesData = [
  {
    id: 1,
    title: "User-Friendly Interface",
    description:
      "A seamless shopping experience with intuitive navigation, search functionality, and personalized recommendations.",
  },
  {
    id: 2,
    title: "Multi-Vendor Marketplace",
    description:
      "Allows multiple sellers to register, list products, and manage orders independently.",
  },
  {
    id: 3,
    title: "Advanced Search & Filters",
    description:
      "Enables users to quickly find products using filters like price, category, brand, and customer ratings.",
  },
  {
    id: 4,
    title: "Secure Payment Integration",
    description:
      "Supports multiple payment methods, including credit/debit cards, digital wallets, and cryptocurrencies.",
  },
  {
    id: 5,
    title: "Order & Inventory Management",
    description:
      "Efficient tools for sellers to track stock, process orders, and update product availability.",
  },
  {
    id: 6,
    title: "Customer Reviews & Ratings",
    description:
      "Allows customers to rate and review products, boosting credibility and sales.",
  },
  {
    id: 7,
    title: "AI-Powered Recommendations",
    description:
      "Machine learning algorithms that suggest products based on user behavior and purchase history.",
  },
  {
    id: 8,
    title: "Mobile App Integration",
    description:
      "A fully responsive mobile app for seamless shopping on smartphones and tablets.",
  },
  {
    id: 9,
    title: "Multi-Currency & Multi-Language Support",
    description:
      "Expands global reach with localized currency and language options.",
  },
  {
    id: 10,
    title: "Secure Admin Panel",
    description:
      "A robust backend to manage orders, users, payments, and overall site operations.",
  },
];
